'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/es-to-primitive/es6.js
// module id = 2094
// module chunks = 1